import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";

Vue.use(Toast);
const baseURL='https://kongjiangerkai.8822128.site/';
//创建axios实例对象
const  instance = axios.create({
    baseURL: baseURL+'/api', //服务器地址
    timeout: 5000, //默认超时时长
    withCredentials: false, // 改为 false，因为服务器设置了 *
})

//请求拦截器
instance.interceptors.request.use(config=>{
    // 初始化 headers
    config.headers = config.headers || {};
    if(localStorage.getItem('token')){
        config.headers['token'] = Base64.encode(localStorage.getItem('token'));
        config.headers['lang'] = localStorage.getItem("lang") || "en";
    }
    // 如果是上传文件，不设置 contentType，让浏览器自动生成
    if (config.isUpload) {
        return config;
    }

    if(config.method === "post"){
        config.headers['content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    }
    
    return config
},err=>{
    console.error('请求失败',err)
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http(option = {}) {
    let result = null
    const isUpload = option.isUpload || false; // 上传标识

    if(option.method === 'get' || option.method === 'delete'){
        //处理get、delete请求
        await instance[option.method](
            api[option.url],
            {params: option.data}
        ).then(res=>{
            result = res.data
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }else if(option.method === 'post' || option.method === 'put'){
        let sendData = null;

        // ======================================
        // 👇 关键：上传文件不加密、不序列化
        // ======================================
        if (isUpload) {
            sendData = option.data; // FormData 直接传
        } else {
            sendData = qs.stringify(option.data); // 普通接口
        }

        await instance[option.method](
            api[option.url],
            sendData,
            { isUpload: isUpload } // 传给拦截器
        ).then(res=>{
            result = res.data;
            // 上传接口一般不返回 base64，所以不解码
            if (!isUpload) {
                result.data = JSON.parse(Base64.decode(result.data));
            }
        }).catch(err=>{
            result = err
        })
    }
    return result
}

export {http,baseURL}

